import AbnormalityIncidentFormContainer from './AbnormalityIncidentFormContainer';

export default AbnormalityIncidentFormContainer;
